import type { PaymentMethodTypeType } from '@subscriptions/domain/types';
import { PaymentMethodTypes } from '@subscriptions/domain/types';

/**
 * Validated payment method type value object (card vs SPEI bank transfer).
 * The empty string represents an absent/unknown method type produced by soft-validation reconstruction.
 */
export type PaymentMethodType = Readonly<PaymentMethodTypeType | ''>;

const validMethodTypes = Object.values(PaymentMethodTypes) as string[];

/**
 * Creates a validated PaymentMethodType value object.
 *
 * @param raw - Raw method type string
 * @returns Validated PaymentMethodType
 * @throws Error if method type is not a valid value
 */
export const createPaymentMethodType = (raw: string): PaymentMethodType => {
  if (!validMethodTypes.includes(raw)) {
    throw new Error(`Invalid payment method type: ${raw}. Must be one of: ${validMethodTypes.join(', ')}`);
  }
  return raw as PaymentMethodType;
};
